import React, { useEffect } from "react";
import { useLenis } from "./SmoothScroll";
import DoneIcon from "@mui/icons-material/Done";
import { Helmet } from "react-helmet-async";

const NoticePP = () => {
  const lenisRef = useLenis();
  useEffect(() => {
    lenisRef?.current?.scrollTo(0); // top of the page
  }, [lenisRef]);
  return (
    <>
     <Helmet>

       <title>Notice of Privacy Practices | CDC Protected Health Info
</title>
        <meta
          name="description"
          content="This notice explains how protected health information and medical records are collected, used, and disclosed at CDC in accordance with privacy regulations."
        />
        <meta
          name="keywords"
          content="notice of privacy practices
protected health information
Medical Records

"
        />
     </Helmet>
      <div className="flex justify-center flex-col items-center  md:pt-20 pt-14 xl:pt-48 ">
        <div className="lg:w-[90%] w-[95%] mx-auto  flex flex-col items-center  pb-8 lg:pb-16">
          <h1 className="lg:text-[52px] text-[28px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  px-4 mb-4 text-center capitalize w-full">
            {" "}
            Notice of Privacy Practices
          </h1>
          <div className="text-left mt-10">
            <h2 className="lg:text-[32px] lg:text-left text-center text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize">
              {" "}
              Citrus Diagnostic Center
            </h2>
            <p className="text-[17px] lg:ps-0 md:px-8 px-4 pb-4 text-[#ccc] mt-5 text-left font-robout">
              This Notice describes how medical information about you may be
              used and disclosed and how you can access this information. Please
              review it carefully.
            </p>

            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              Our Responsibilities
            </h2>
            <p className="text-[17px] text-[#ccc] lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              We are required by law to maintain the privacy and security of
              your protected health information (PHI). We will notify you
              promptly if a breach occurs that may have compromised the privacy
              or security of your information.
            </p>

            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              How We May Use and Share Your Information
            </h2>
            <p className="text-[17px] text-[#ccc] lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              We may use and disclose your health information for purposes of:
            </p>
            <ul className="flex flex-col text-[17px] gap-3 text-[#ccc]  pb-8  text-left font-robout">
              <li className="flex items-start text-[17px] gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span className="">Treatment </span>{" "}
              </li>
              <li className="flex items-start text-[17px] gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span className="">Payment </span>{" "}
              </li>
              <li className="flex items-start text-[17px] gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span className="">Healthcare operations </span>{" "}
              </li>
            </ul>

            <p className="text-[17px] text-[#ccc] lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              This includes, but is not limited to, sharing information with
              referring providers, interpreting physicians, billing services,
              and healthcare entities involved in your care, as permitted by
              law.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              Your Rights
            </h2>
            <p className="text-[17px] text-[#ccc] lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              You have the right to:
            </p>
            <ul className="flex flex-col gap-3 text-[#ccc]  pb-8  text-left font-robout">
              <li className="flex items-start text-[17px] gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span className="">
                  Access and obtain a copy of your medical records{" "}
                </span>{" "}
              </li>
              <li className="flex items-start text-[17px] gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span className="">
                  Request corrections to your medical information{" "}
                </span>{" "}
              </li>
              <li className="flex items-start text-[17px] gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span className="">
                  Request restrictions on certain uses or disclosures
                </span>{" "}
              </li>

              <li className="flex items-start text-[17px] gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span className="">
                  Request confidential communications
                </span>{" "}
              </li>
              <li className="flex items-start text-[17px] gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span className="">
                  Receive a list of certain disclosures we have made{" "}
                </span>{" "}
              </li>
              <li className="flex items-start text-[17px] gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span className="">
                  Obtain a paper or electronic copy of this Notice
                </span>{" "}
              </li>
            </ul>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              Electronic Records & Patient Portal
            </h2>
            <p className="text-[17px] text-[#ccc] lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              Your medical information may be maintained in electronic form.
              Secure access to medical records, reports, and communications is
              provided through our official patient portal.
            </p>
            <p className="text-[17px] text-[#ccc] lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              This website itself does not collect or store protected health
              information.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              Our Website
            </h2>
            <p className="text-[17px] text-[#ccc] lg:ps-0 md:px-8 px-4 pb-2  text-left font-robout">
              This website is provided for informational purposes only. We do
              not collect or store PHI through this website. Any patient
              information is handled through secure systems and portals designed
              for that purpose.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              Questions or Complaints
            </h2>
            <p className="text-[17px] text-[#ccc] lg:ps-0 md:px-8 px-4 pb-4  text-left font-robout">
              If you have questions about this Notice or believe your privacy
              rights have been violated, you may contact our office directly.
              You may also file a complaint without fear of retaliation.
            </p>
            <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              Effective Date
            </h2>
            <p className="text-[17px] text-[#ccc] lg:ps-0 md:px-8 px-4 pb-6  text-left font-robout">
              January 1, 2026
            </p>
            {/* <h2 className="lg:text-[32px] text-[24px] leading-[1.4em] font-normal text-[#cccccc] lg:ps-0 md:px-8 px-4 pt-10 pb-5">
              View as a PDF
            </h2> */}

            <a
              href="./notiveofprivacypolicy.pdf"
              download="Notice of Privacy Policy.pdf"
              target="_blank"
              className="  text-2xl pt-4 text-[#ccc] font-normal underline"
            >
              Download or View PDF
            </a>
          </div>
        </div>
      </div>{" "}
    </>
  );
};

export default NoticePP;
